import { useLazyGetMeQuery } from "app/api/customer/customerApi";
import useLogout from "hooks/auth/useLogout";
import useLocaleNavigate from "hooks/reactRouterWrappers/useLocaleNavigate";
import { Fragment, FunctionComponent, ReactElement, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { setLoginRedirect, setState } from "redux/auth/authSlice";
import { useDispatch, useSelector } from "redux/hooks";

interface RequireAuthProps {
	children: ReactElement;
}

const RequireAuth: FunctionComponent<RequireAuthProps> = ({ children }) => {
	const store = useSelector((state) => state.bcStore.store);
	const dispatch = useDispatch();
	const location = useLocation();
	const navigate = useLocaleNavigate();

	const logout = useLogout(true);
	const { loginRedirect, customer, state } = useSelector(
		(state) => state.auth,
	);

	const identifier = useSelector((state) => state.auth.identifier);
	const identifierLoaded = useSelector((state) => state.auth.identifierLoaded);

	const [me] = useLazyGetMeQuery();


	useEffect(() => {
		if (loginRedirect) {
			const redirect = loginRedirect;

			dispatch(setLoginRedirect(undefined));
			navigate(redirect, { state });
		}
	}, [loginRedirect, dispatch, navigate, state]);



	useEffect(() => {
		if (!identifierLoaded) return;

		if (store && identifier) {
			if (!identifier.storeHash && customer.id) {
				getCustomerDetails();
			}

			if (identifier.storeHash && !customer.id) {
				getCustomerDetails();
			}

			if ((identifier.storeHash || customer.id) && location.pathname.includes("account")) {
				getCustomerDetails();
			}

			if (!identifier.storeHash) {
				dispatch(setLoginRedirect(location.pathname));
				dispatch(setState(location.state));
				logout(store.hash, false);
			}
		}
	}, [store, identifier, identifierLoaded]);

	const getCustomerDetails = async () => {
		await me()
			.unwrap()
			.then((res) => {
				if (!res.success || !res.data) {
					logout();
				}
			})
			.catch((error: any) => {
				logout();
			});
	};

	if (!identifier.storeHash || !customer) {
		return null;
	}

	if (loginRedirect) {
		// Don't dispatch or navigate here
		return null;
	}

	return <Fragment>{children}</Fragment>;
};

export default RequireAuth;
